import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_BOOLEAN_ICON } from "../../../../theme/Component/BasicTable";
import { useEffect } from "react";
import usePaginator from "../../../../theme/Component/usePaginator";
import { _LaboralPosition, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectFunctionalArea } from "../SelectFunctionalArea";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";

interface Props {
    ObjfunctionalID: Record<string, any>;
}

export const LaboralPosition = ({ ObjfunctionalID }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_LaboralPosition);
    const paginador = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Plaza Sucesora", MODAL_md);

    useEffect(() => {
        console.log(ObjfunctionalID)
        if (ObjfunctionalID.IDLn) {
            getLista();
        }
    }, [ObjfunctionalID.IDLn])

    const getLista = () => {
        const props = {
            IDLn: ObjfunctionalID.IDLn,
            State: 1
        }
        instance.getLaboralPositionRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15);

                resp.List.forEach((element: any, index: number) => {
                    const position = element.DataBeanProperties ?? element;
                    resp.List[index] = {
                        DataBeanProperties: {
                            ...position,
                            SuccesorEntity: renderSuccessorEntity(position),
                        },
                    };
                });

                setLista(resp.List);
                setBean({});
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const renderSuccessorEntity = (position: any) => {
        if (!position.IDLnSuccessor) {
            return "N/P";
        }

        if (!Array.isArray(position.Contracts) || position.Contracts.length === 0) {
            return `${position.IDLnSuccessor} - N/P - N/P`;
        }

        let render = "";
        position.Contracts.forEach((item: any) => {
            const contract = item.DataBeanProperties ?? item;
            const appointmentName = contract.AppointmenName ?? "N/P";
            const accountFullName = contract.AccountFullName?.trim() || "N/P";

            render += `${position.IDLnSuccessor} - ${appointmentName} - ${accountFullName}<br />`;
        });

        return render;
    }

    const head = [
        { title: 'ID', property: 'IDLaboralPosition', visible: true },
        { title: 'Prioridad', property: 'PriorityOrder', visible: true },
        { title: 'Tipo de Ausencia', property: 'ReasonName', visible: true },
        { title: 'Plaza sucesora', property: 'SuccesorEntity', visible: true },
        { title: 'Requiere acto administrativo', property: 'RequiresAct', visible: true, mask: MASK_BOOLEAN_ICON },
    ];

    const create = () => {
        setBean({
            IDLn: ObjfunctionalID.IDLn,
            State: 1,
            RequiresAct: false,
        });
        modal.open("Agregar Plaza Sucesora");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Plaza sucesora"); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        const data = { ...bean, State: 2 }
        editaItem(data)
    };

    const editaItem = (obj: any) => {
        if (obj.State !== 2 && obj.IDLn === obj.IDLnSuccessor) {
            toast.error("No puede seleccionar la misma plaza como plaza sucesora");
            return;
        }

        instance
            .updateLaboralPosition({
                ...obj,
                IDEmployee: _single.getAccountID(),
            })
            .then(() => {
                getLista();
                modal.close();
                modalC.close();
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    records={paginador}
                />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label >Plaza Sucesora</label>
                            <SelectFunctionalArea value={bean.IDLnSuccessor} onChange={(e) => { setBean({ ...bean, IDLnSuccessor: e.IDLn }) }} label="" />
                        </div>
                        <div className="col-md-12">
                            <label>Prioridad</label>
                            <input type="number" className="form-control" value={bean.PriorityOrder} onChange={(e) => { setBean({ ...bean, PriorityOrder: e.target.value ? Number(e.target.value) : null }) }} />
                        </div>

                        <div className="col-md-12">
                            <label className="form-label">Tipo de Ausencia</label>
                            <SelectTHConstantsValue label=" " code={400} onChange={(e) => { setBean({ ...bean, IDReasonTypePS: e }) }} value={bean.IDReasonTypePS} />
                        </div>

                        <div className="col-md-12">
                            <BasicSwitch label="Requiere Acto Administrativo" estado={bean.RequiresAct} eventChange={(e) => { setBean({ ...bean, RequiresAct: e }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <p>Desea eliminar la sucecion {bean.IDLaboralPosition}</p>
                        </div>
                    </div>
                </Modal>

            </div>
        </div>
    )
}
